module.exports = __webpack_public_path__ + "static/img/v_ba_p_3_1.7eb63175.png";